export * from './msms-utils.module';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/tslint-loader?emitErrors=false&failOnHint=false!./src/index.ts